<template>
  <v-checkbox
    v-model="computedValue"
    :color="config.color || '#163D73'"
    :label="config.label || ''"
    :direction="config.direction || 'horizontal'"
    :hide-details="config.hideDetails || 'auto'"
    :error-messages="getValidationErrors()"
    :error-count="getValidationErrors().length"
    class="checkbox-field"
    :disabled="disabled"
    @input="event => $emit('onInput', event)"
    @change="onChange"
  />
</template>

<script>
import { isEmpty } from 'lodash'

export default {
  name: 'CheckboxField',

  emits: [
    'onInput',
    'input',
    'change',
    'clear-validation-errors'
  ],

  props: {
    value: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    },
    validationErrors: {
      type: Object,
      default: () => ({})
    },
    customFieldKey: {
      type: String,
      default: ''
    }
  },

  computed: {
    computedValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },

  methods: {
    onChange (val) {
      this.$emit('change', !!val)
      this.$emit('clear-validation-errors')
    },

    getValidationErrors () {
      let messages = []
      const { key } = this.config || {}

      if (!key || typeof key !== 'string' || isEmpty(this.validationErrors) || this.disabled) {
        return messages
      }

      for (const errorKey in this.validationErrors) {
        if (errorKey === key) {
          messages = this.validationErrors[errorKey]
        }
        else if (errorKey === this.customFieldKey) {
          messages = this.validationErrors[errorKey]
        }
      }

      return messages
    }
  }
}
</script>

<style scoped>
.checkbox-field {
  margin-top: 0;
}
</style>
